<template>
  <span>{{ duration | toTimeFormat }}</span>
</template>

<script>
import padStart from 'lodash/padStart';

export default {
  filters: {
    toTimeFormat(time) {
      const roundedTime = Math.round(time);
      const numMin = Math.floor(roundedTime / 60).toFixed(0);
      const numSecond = (roundedTime % 60).toFixed(0);
      return `${padStart(numMin, 2, '0')}:${padStart(numSecond, 2, '0')}`;
    },
  },
  props: {
    duration: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style>

</style>
